/**
 * 아이디·비밀번호 찾기 (옛 화면 signup/findmem — 머큐리·구 악덕알리미 앱이 /m/findmem 으로 연다)
 * ($j.Pages.Mobile.FindMem / body data-page-name="FindMem")
 *
 * 결과·버튼 칸(#idResult·#idConfirm·#idCheck·#findPwd·#naverLogin·#kakaoLogin)은 .fm-off 로 여닫는다 —
 * display--flex 칸이라 show() 로 열면 block 이 된다. window.inicisCallback 은 이니시스 창이 부른다.
 */
export default class FindMem {
    initialize() {
        // 본인인증 생략(개발 서버) — F/Inicis 가 G5['inicisByPass'] 를 본다
        G5['inicisByPass'] = JSON.parse(document.getElementById('page-data')?.textContent || '{}').inicisByPass;

        // 마크업의 버튼·링크 (예전 onclick·href=javascript:)
        const ACT = {
            'id-check':   () => idCheck(),
            'inicis-id':  () => startInicis('id'),
            'find-pw':    () => findPwModal(),
            'change-pwd': () => changePwd(),
        };
        $(document).on('click', '[data-fm]', function (e) { e.preventDefault(); ACT[this.dataset.fm](); });
        $(document).on('click', '#idResult [data-sns]', function (e) { e.preventDefault(); $j.F.Social.login(this.dataset.sns); });
        $('#passForm').on('submit', (e) => e.preventDefault());

            // 간편인증 여부
            let idAuth = false;
            let passAuth = false;
            $(function () {
                initPage();
                initHandler();
            });

            /**
             * 페이지 초기화
             */
            function initPage(){
                $('#find--pwd').hide();// 페이지 로드 시 기본으로 아이디 찾기 섹션만 표시
                inputIconClass();
            }

            /**
             * 이벤트 핸들러 초기화
             */
            function initHandler(){
                idpassSelector(idAuth, passAuth);
                pwdValidator(); // 페이지 로드 시 유효성 검사 초기화
                //비밀번호 찾기 페이지 확인 버튼 비활성화
                $('#passForm').on('change keyup input',function(e){
                    e.preventDefault();
                    if ($('#userPw').val() && $('#userPw2').val() && $('#passForm').valid()) {
                        $('#pwdButton').removeClass('button-disabled');
                    } else {
                        $('#pwdButton').addClass('button-disabled');
                    }
                });
                initTogglePassword();

                // 인증완료시
                $j.Common.EventBus.on(G5['NS'], 'sms:auth', (e, data) => {
                    // console.log('sms인증 이벤트 발생:', data);
                    // alert(JSON.stringify(data));
                    $j.Common.Util.swalert(data.message);
                    if( data.result) $j.F.SmsAuth.close();
                });
            }

            function findPwModal(){
                $j.F.SmsAuth.start('pass');
            }

            /**
             * 아이디 비밀번호 셀렉터
             * ul에서 아이디 찾기, 비밀번호 찾기 클릭 시 화면 div 표시
             * on 클래스는 상단 아이디 찾기, 비밀번호 찾기 text css.
             * @param $idAuth id 간편인증 여부
             * @param $passAuth password 간편인증 여부
             */
            function idpassSelector(idAuth, passAuth) {
                $('#ul-list li a').click(function (e) {
                    e.preventDefault(); // 기본 동작을 막음

                    const targetId = $(this).attr('id'); // data-target 속성값을 가져옴

                    // 모든 a 태그에서 on 클래스를 제거
                    $('#ul-list li a').removeClass('on');
                    $('#ul-list').removeClass('tabPwd');
                    $('#ul-list').removeClass('tabId');

                    // 클릭된 a 태그에 on 클래스를 추가
                    $(this).addClass('on');

                    /* 추가 */
                    $('#ul-list').addClass(targetId);

                    // 모든 div 요소 숨김
                    $('#find--id, #find--pwd').hide();
                    $('#idResult').addClass('fm-off');

                    // 선택된 요소에 따라 표시/숨김 처리
                    if (targetId === 'tabId') {
                        $('#find--id').show().addClass('on');
                        if (!idAuth) {
                            $('#idResult').addClass('fm-off');
                            $('#find--id').show();
                        } else {
                            $('#find--id').hide();
                            $('#idResult').removeClass('fm-off');
                        }
                    } else {
                        $('#find--pwd').show().addClass('on');
                        $('#find--id').removeClass('on');
                        $('#pwdButton').addClass('button-disabled');
                        if (!passAuth) {
                            $('#pwdForm').hide();
                            $('#findPwd').removeClass('fm-off');
                        } else {
                            $('#findPwd').addClass('fm-off');
                            $('#pwdForm').show();
                        }
                    }
                });
            }

            /**
             * 비밀번호 보이기 토글
             * @param passwordType 비밀번호 타입
             * @param iconType 눈모양 아이콘
             */
            function initTogglePassword() {
                function togglePassword(passwordType, iconType) {
                    const input = $(passwordType);
                    const icon = $(iconType).find('img');
                    const type = $(passwordType).attr('type') === 'password' ? 'text' : 'password';
                    input.attr('type', type);
                    icon.attr('src', type === 'password' ? '/img/mercury/screet-icon.svg' : '/img/mercury/screetx-icon.svg');
                }

                $('#togglePassword').click(function () {
                    togglePassword('#userPw', this);
                });

                $('#togglePasswordConfirm').click(function () {
                    togglePassword('#userPw2', this);
                });
            }

            /**
             * 인풋박스에 입력값이 있다면 활성화 아이콘으로 변경
             * @param input 인풋박스 입력값 유무
             */
            function inputIconClass(input){
                const icon = $(input).closest('.id-pw-find-page__input-wrapper').find('.id-pw-find-page__icon');
                if ($(input).val()) {
                    icon.addClass('active');
                } else {
                    icon.removeClass('active');
                }
            }

            // 모든 인풋 필드에 대해 초기화
            $('.id-pw-find-page__input').each(function() {
                inputIconClass(this);
            });

            // input 이벤트 처리
            $('.id-pw-find-page__input').on('input', function() {
                inputIconClass(this);
            });

           /**
            * 본인인증에 성공하면 비밀번호 변경을 위한 인풋을 화면에 보여준다.
            */
            function updatePassAuth() {
                passAuth = true;
                idpassSelector(idAuth, passAuth);
                $('#pwdForm').show();
                $('#findPwd').addClass('fm-off');
                // pwdValidator()
            }

            /**
             * 비밀번호 유효성 검사
             */
            function pwdValidator() {
                //비밀번호 정규식
                $.validator.addMethod("pattern", function (value, element) {
                    return this.optional(element) || $j.Core.Config.PASSWORD_RE.test(value);
                });
                // FORM VALIDATOR 설정
                $('#passForm').validate({
                    rules: {
                        mem_pwd: {
                            required: true,
                            pattern: true
                        },
                        mem_pwd2: {
                            required: true,
                            equalTo: "#userPw"
                        }
                    },
                    messages: {
                        mem_pwd: {
                            required: "비밀번호를 입력해 주세요.",
                            pattern: $j.Core.Config.PASSWORD_MSG
                        },
                        mem_pwd2: {
                            required: "비밀번호를 다시 입력해 주세요.",
                            equalTo: "비밀번호가 일치하지 않습니다."
                        }
                    },
                    errorPlacement: function (error, element) {
                        error.insertAfter(element.parent());
                    },
                    invalidHandler: function (form, validator) {
                        $('#pwdButton').addClass('button-disabled');
                    },
                    success: function(label) {
                        $('#pwdButton').removeClass('button-disabled'); // 유효성 검사가 성공하면 버튼을 활성화
                    }
                });
            }

            /**
             * 비밀번호 변경
             */
            function changePwd() {
                if ($('#pwdButton').hasClass('button-disabled')) {
                    return; // 버튼이 비활성화된 상태라면 함수 종료
                }
                const memPwd = $('#userPw').val();

                $.ajax({
                    url: '/m/ajax/member/password/reset-after-inicis',
                    method: 'POST',
                    data: {
                        mem_pwd: memPwd,
                    },
                    success: async function (response) {
                        if (response.success) {
                            // 반드시 답해야 하는 창 — ✕·백드롭·ESC 를 막는다(구 모달의 showClose/clickClose/escapeClose:false 자리)
                            await $j.Ui.Dialog.alert('비밀번호 변경이 완료되었습니다.', {
                                tone: 'success', dismissible: false,
                            });
                            location.replace('/m/login');
                        } else {
                            $j.Common.Util.swalert(response.message);
                        }
                    },
                    error: function (xhr, status, error){
                        $j.Common.Util.swalert('비밀번호 변경 중 오류가 발생했습니다.');
                    }
                })
            }

            /* 아이디 찾기 토글메뉴 + jQuery 애니메이션 */
            $(document).ready(function() {
                const box1 = $('#find_id_txtbox');
                const box2 = $('#find_id_txtbox2');
                const inbox1 = $('#find_id_inbox');
                const inbox2 = $('#find_id_inbox2');

                function toggleBox(which) {
                    const isBox1Open = box1.hasClass('active');
                    const isBox2Open = box2.hasClass('active');

                    if (which === 1) {
                        if (isBox1Open) {
                            inbox1.slideUp(200);
                            box1.removeClass('active');
                            box2.removeClass('dimmed');
                        } else {
                            inbox1.slideDown(200);
                            box1.addClass('active');
                            box2.removeClass('active');
                            inbox2.slideUp(200);
                            box2.removeClass('active');
                            box2.addClass('dimmed');
                            box1.removeClass('dimmed');
                        }
                    } else if (which === 2) {
                        if (isBox2Open) {
                            inbox2.slideUp(200);
                            box2.removeClass('active');
                            box1.removeClass('dimmed');
                        } else {
                            inbox2.slideDown(200);
                            box2.addClass('active');
                            box1.removeClass('active');
                            inbox1.slideUp(200);
                            box1.removeClass('active');
                            box1.addClass('dimmed');
                            box2.removeClass('dimmed');
                        }
                    }
                }

                // 제목 영역(span, h2, p) 클릭 시에만 열리도록 제한
                box1.on('click', function(e) {
                    if (!$(e.target).closest("#find_id_inbox").length) {
                        toggleBox(1);
                    }
                });

                box2.on('click', function(e) {
                    if (!$(e.target).closest("#find_id_inbox2").length) {
                        toggleBox(2);
                    }
                });
            });

            /**
             * 아이디 찾기 중 회원 정보로 찾기
             */
            function idCheck(){
                let mem_name = $('#user_name').val();
                // let first_num = $('#find_id_fnum').val();
                // let input_phone = $('#user_lnum').val();
                // let middle_num, last_num
                // if (first_num === 'self_phone') {
                //     first_num = $('#self_input').val();
                // }
                // if (input_phone.length === 8) {
                //     middle_num = input_phone.substring(0,4);
                //     last_num = input_phone.substring(4);
                // } else {
                //     middle_num = input_phone.substring(0,3);
                //     last_num = input_phone.substring(3);
                // }

                let first_num = $('#fnum-list').val();

                // 직접입력 선택 시
                if (first_num === 'custom') {
                    first_num = $('.fnum_custom input').val();
                }

                let mem_phone = first_num + '-' + $('#user_lnum').val();
                mem_phone = $j.Common.Util.phoneNumber(mem_phone);
                $.ajax({
                    url: '/m/ajax/member/find/id',
                    method: 'get',
                    data: {
                        real_name: mem_name,
                        mem_phone: mem_phone,
                    },
                    success: function (response) {
                        response.type = 'find';
                        handleIdResponse(response);
                    },
                    error: function (xhr, status, error) {
                        alert('오류가 발생했습니다. 다시 시도해 주세요.');
                    }
                });
            }
            // function togglePhoneInput() {
            //     $('#find_id_fnum').change(function () {
            //         if ($(this).val() === 'self_phone') {
            //             $('#selfInput').show();
            //             $('#find_id_fnum').css("color", "#fff");
            //         } else {
            //             $('#selfInput').hide();
            //             $('#find_id_fnum').css("color", "#121212");
            //         }
            //     });
            // }

            /**
             * 아이디 패스워드 간편인증 정보 전송
             * @param type id 는 아이디 찾기 , pass 는 비밀번호 변경
             */
            function startInicis(type) {
                //  type에 따라 successUrl, failUrl 변경 'id','pass'
                let callbackUrl = '';
                if (type == 'id') {
                    callbackUrl = $j.Common.Util.getHost()+`/m/plugin/inicis/callback/${type}`;

                }
                else if (type == 'pass') {
                    callbackUrl = $j.Common.Util.getHost()+`/m/plugin/inicis/callback/${type}`;
                }
                $j.F.Inicis.auth({
                    'successUrl': callbackUrl,
                    'failUrl': callbackUrl,
                    type
                });
            }

            /**
             * 소셜회원이 최초로 이니시스 인증후 콜백함수
             * @param data
             */
            // 이니시스 인증 창이 결과를 돌려준다 — 창 사이 약속이라 window 에 둔다
            window.inicisCallback = inicisCallback;
            function inicisCallback(data){
                if(!data.result){
                    $j.Common.Util.swalert(data.message);
                    return;
                }

                if(data.type == 'id'){
                    handleIdResponse(data.info);
                }
                else if(data.type == 'pass'){
                    updatePassAuth();
                }
            }

            /**
             * 아이디 찾기 결과에 따라 각종 버튼을 만들어준다.
             * @param info mem_id, sns_type(k, n), type (auth : 본인인증, find: 회원정보로 찾기)
             */
            function handleIdResponse(info) {
                $('#idConfirm').addClass('fm-off');
                $('#idCheck').addClass('fm-off');

                let mem_id = info.mem_id;
                let sns_type = info.sns_type;

                if (mem_id) {
                    // mem_id가 소셜아이디인경우 #jb_login 숨기기
                    if ($j.Common.Util.isSocialId(mem_id)) {
                        $('#jbLogin').hide(); // jb_login 숨기기
                        $('#findPass').hide();
                    }

                    switch (sns_type) {
                        case 'K': // 카카오 계정이 있을 때
                            $('#kakaoLogin').removeClass('fm-off'); // 카카오 로그인 버튼 보이기
                            $('#naverLogin').addClass('fm-off'); // 네이버 로그인 버튼 숨기기
                            break;
                        case 'N': // 네이버 계정이 있을 때
                            $('#naverLogin').removeClass('fm-off'); // 네이버 로그인 버튼 보이기
                            $('#kakaoLogin').addClass('fm-off'); // 카카오 로그인 버튼 숨기기
                            break;
                        // default: // sns_type이 null 또는 다른 값일 때
                        //     $('#kakaoLogin').addClass('fm-off'); // 카카오 로그인 버튼 숨기기
                        //     $('#naverLogin').addClass('fm-off'); // 네이버 로그인 버튼 숨기기
                        //     break;
                    }

                    // 아이디 찾기 타입에 따라 버튼 속성 부여
                    const button = document.getElementById('findPassBtn');

                    // 결과 창 표시 및 입력 폼 숨기기
                    $('#idResult').removeClass('fm-off');
                    $('#find--id').hide();

                    // 아이디를 마스킹 처리해서 보여주거나 전체를 보여주는 부분
                    if (info.type === 'auth') {
                        // 본인인증을 통해서 온 경우 (전체 아이디를 보여줌)
                        $('#userId').text(mem_id);
                        $('#idCheck').removeClass('fm-off');
                        button.textContent = "비밀번호 재설정"
                        button.onclick = function() {
                            $('#tabPwd').trigger('click');
                            updatePassAuth();
                        };
                    } else {
                        // 일반적인 아이디 찾기인 경우 (마스킹 처리)
                        const maskedId = mem_id.slice(0, -3) + '***';
                        $('#userId').text(maskedId);
                        $('#idConfirm').removeClass('fm-off');
                        button.onclick = function() {
                            $('#tabPwd').trigger('click');
                            idpassSelector(idAuth, passAuth);

                        };
                    }

                } else {
                    // 실패한 경우 메시지를 alert로 표시
                    $j.Common.Util.swalert('아이디를 찾을 수 없습니다.');
                }
            }

            // 키보드 올라올 때 info_box 숨김
            window.addEventListener('resize', () => {
                const docHeight = window.innerHeight;
                const footer = document.querySelector('.info_box');
                if (docHeight < 500) {
                    // 키보드 올라왔다고 간주
                    footer.style.display = 'none';
                } else {
                    footer.style.display = 'block';
                }
            });

            //셀렉트박스 드롭다운 + jQuery 애니메이션
            $(document).ready(function() {
                const dropdown = $(".select_box");
                const selected = dropdown.find(".selected");
                const listItems = dropdown.find(".num_list li");

                selected.on("click", function() {
                    const numList = $(this).siblings(".num_list");

                    if (dropdown.hasClass("open")) {
                        // 닫기
                        numList.slideUp(200);
                        dropdown.removeClass("open");
                    } else {
                        // 열기
                        numList.slideDown(200);
                        dropdown.addClass("open");
                    }
                });

                listItems.on("click", function() {
                    if (!$(this).hasClass("custom-input")) {
                        selected.html(`${$(this).text()} <span class="arrow"><i class="fas fa-chevron-down"></i></span>`);
                        selected.data("value", $(this).text());
                    } else {
                        // "직접입력" 클릭 시 input 필드로 교체
                        selected.html(`<input type="text" placeholder="번호 입력" class="custom-phone-input">`);
                        selected.data("value",'');
                        const input = selected.find("input");
                        input.focus();
                    }

                    // 드롭다운 닫기
                    dropdown.find(".num_list").slideUp(200);
                    dropdown.removeClass("open");
                });

                // 바깥 클릭 시 닫기
                $(document).on("click", function(e) {
                    if (!dropdown.is(e.target) && dropdown.has(e.target).length === 0) {
                        dropdown.find(".num_list").slideUp(200);
                        dropdown.removeClass("open");
                    }
                });
            });

            // 셀렉트 박스(공통)
            $('[data-select-target]').each((_, el) => $('#' + $(el).data('select-target')).mobiscroll().select({
                inputElement: document.getElementById($(el).attr('id')),
                display: 'bottom', theme: 'material', touchUi: true, rows:3, setText: '선택', cancelText: '취소'
            }));
    }
}
